import { format } from 'date-fns'

import type { Match, Stream, StreamMatch } from 'types'

export const getMatchDayInDateRange = (match: Match, minDate: Date, dateFormat: string = 'eeee do MMMM yyyy') => {
  if (!match.matchDays) return
  const matchDate = match.matchDays.find(day => day.dateTimeUTC && new Date(day.dateTimeUTC) > minDate)?.dateTimeUTC
  if (!matchDate) return
  return format(new Date(matchDate), dateFormat)
}

type GetMatchesForStreamsProps = {
  streams: Stream[]
  matches: Match[]
  startDate: Date
  endDate: Date
}

export const getMatchesForStreams = ({
  streams,
  matches,
  startDate,
  endDate,
}: GetMatchesForStreamsProps): StreamMatch[] => {
  const matchesForStreams: StreamMatch[] = []
  matches.forEach(match => {
    const streamsForMatches = streams?.filter(stream => stream.externalId === match.id)
    if (!streamsForMatches) return

    streamsForMatches.forEach(stream => {
      const streamMatchDay = match.matchDays?.find(day => day.dayNum === stream.instanceNumber)
      if (
        (stream.startUtc && (stream.startUtc < startDate.toISOString() || stream.startUtc > endDate.toISOString())) ||
        (!stream.startUtc &&
          (!streamMatchDay?.dateTimeUTC ||
            streamMatchDay.dateTimeUTC < startDate.toISOString() ||
            streamMatchDay.dateTimeUTC > endDate.toISOString()))
      ) {
        // for RUN/STOP statused streams, check if start time is out of the date bounds
        // for CONFIGURED statused streams, check if the start time for the day/instanceNumber is out of the date bounds
        // if we are out of the date bounds, do not include this match/stream combo in our response
        return
      }
      matchesForStreams.push({
        ...match,
        instanceNumber: stream.instanceNumber,
      })
    })
  })
  return matchesForStreams
}

export const isMatchDayInDateRangeDifferent = (match: Match, prevMatch: Match, minDate: Date) => {
  if (!match.matchDays) return false
  if (!prevMatch.matchDays) return true
  const matchDate = match.matchDays.find(day => day.dateTimeUTC && new Date(day.dateTimeUTC) > minDate)?.dateTimeUTC
  const prevMatchDate = prevMatch.matchDays.find(
    day => day.dateTimeUTC && new Date(day.dateTimeUTC) > minDate
  )?.dateTimeUTC
  if (!matchDate || !prevMatchDate) return true
  return format(new Date(matchDate), 'yyyy-MM-dd') !== format(new Date(prevMatchDate), 'yyyy-MM-dd')
}
